export const css = {
    popupContainer: 'S92Yj5cs',
    above: '_1PRrGVVh',
    below: '_2b2bjLCa',
    popup: 'P34xfr7m',
    popupControls: '_19645QyT',
    cancelRoot: '_1V8D7Itn _12yR4Zxn',
    confirmRoot: '_Brm5jRv _12yR4Zxn',
    ' _key': 'certwise-theme/dojo/popup-confirmation'
};
export default css;
